import { Head, usePage } from '@inertiajs/react'
import { createElement } from 'react'
import type { InertiaMetaTag, SharedMarketingProps } from '@/types/marketing'

function normalizeTag(meta: InertiaMetaTag) {
  return {
    tagName: String(meta.tagName ?? meta.tag_name ?? (meta.title ? 'title' : 'meta')),
    innerContent: meta.innerContent ?? meta.inner_content ?? meta.title ?? null,
    headKey: String(meta.headKey ?? meta.head_key ?? meta.name ?? meta.property ?? meta.rel ?? meta.tagName ?? meta.tag_name ?? 'meta')
  }
}

export default function MetaTags() {
  const { props } = usePage<SharedMarketingProps>()
  const metaTags = Array.isArray(props._inertia_meta) ? props._inertia_meta : []

  if (!metaTags.length) return null

  return (
    <Head>
      {metaTags.map((meta, index) => {
        const { tagName, innerContent, headKey } = normalizeTag(meta)
        const attributes: Record<string, unknown> = {
          key: `${headKey}-${index}`,
          'head-key': `${headKey}-${index}`
        }

        Object.entries(meta).forEach(([rawKey, value]) => {
          if (value == null) return
          if (['tagName', 'tag_name', 'innerContent', 'inner_content', 'headKey', 'head_key', 'title'].includes(rawKey)) return

          const key = rawKey === 'httpEquiv' || rawKey === 'http_equiv' ? 'http-equiv' : rawKey
          attributes[key] = value
        })

        return createElement(tagName, attributes, typeof innerContent === 'string' ? innerContent : innerContent != null ? JSON.stringify(innerContent) : undefined)
      })}
    </Head>
  )
}
